import Vue from 'vue'
export const enumReasult = (res) => {
  if(res.code==0)return //不处理

  if(res.code>=400 && res.code<=499)return new Vue().$notify.error({
    title: '错误',
    message: '客户端输入异常',
    duration: 2000
  });

  if(res.code>=500 && res.code<=599)return new Vue().$notify.error({
    title: '错误',
    message: '服务端处理异常',
    duration: 2000
  });
  if(res.code>=600 && res.code<=699)return new Vue().$message.error({
    title: '错误',
    message: res.message,
    duration: 2000
  });
  if(res.code==999)return new Vue().$notify.error({
    title: '错误',
    message: '未知异常，请立即联系开发人员',
    duration: 2000
  });

}


export const clearAllCookie = () => {
  var keys=document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i =  keys.length; i--;)
      setCookie(keys[i],0,-1)
  }
}
function setCookie(name,value,min)
{
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + min*1000);
  document.cookie = name + '='+ escape (value) + ';expires=' + exp.toGMTString();
}



